import Episode from "@/containers/Episode";
import Episodes from "@/containers/Episodes";
import { AudioPlayerContextProvider } from "@/contexts/GlobalAudioPlayerContext";
import { Episode as EpisodeType, EpisodeDataset } from "@/types/Episode";

import { BaseWidget } from "../BaseWidget";
import { PackedWidgetData, unpackWidgetData } from "./utils";
import { WidgetProps } from "./WidgetProps";

type TopMentionsData = PackedWidgetData<EpisodeDataset>;

const TopMentions: React.FunctionComponent<WidgetProps<TopMentionsData>> = (
  props
) => {
  const { data } = props;
  const chartData = unpackWidgetData<EpisodeDataset>(data);

  const hasData = chartData.datasets?.some(({ data }) => !!data.length);

  return (
    <BaseWidget
      // The types here should be fixed within BaseWidget. That is out of scope for now.
      hasData={hasData}
      {...props}
      title={L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_MENTIONS_TABLE}
      description={
        L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOP_MENTIONS_TABLE_SUBTITLE
      }
      hideOverflow={true}
    >
      {chartData.datasets?.length > 0 ? (
        <AudioPlayerContextProvider>
          <Episodes>
            {chartData.datasets.map(({ data }) =>
              data.map((episode: EpisodeType) => (
                <Episode
                  className=""
                  key={episode.episode_uuid}
                  {...episode}
                  hideActions
                  hideSimilar
                  hideTags
                  visibleMentions={2}
                />
              ))
            )}
          </Episodes>
        </AudioPlayerContextProvider>
      ) : null}
    </BaseWidget>
  );
};

export default TopMentions;
